import { Fragment, useEffect, useState } from 'react';
import { Dialog, Transition, RadioGroup } from '@headlessui/react';
import { X, Check } from 'lucide-react';
import { Client } from '@api/index';
import { Button } from '@pw-tech/omni-ui';
import { format } from 'date-fns';


export default function MahapackPlanModal({ isOpen, onClose, batchDetails, handleMahapackPaymentClose }: any) {
    const [selected, setSelected] = useState<any>();
    const [plans, setPlans] = useState([])

    const getPlanDetails = async (id: string) => {
        const userId = JSON.parse(localStorage.getItem("user") || "{}")?.id || ""
        try {
            if (typeof window !== 'undefined') {
                const response: any = await Client.get(
                    `${process.env.REACT_APP_PP_API_BASE_URL}/v1/student-acquisition/ambassador-client/${id}/plans/${userId}`
                )
                setPlans(response?.data?.data?.plans)
                setSelected(response?.data?.data?.plans?.find((item: any) => item?.isBest))
            }
        } catch (err: any) { }
    }
    useEffect(() => {
        if (batchDetails) {
            getPlanDetails(batchDetails?._id)
        }
    }, [batchDetails])

    return (
        <Transition appear show={isOpen} as={Fragment}>
            <Dialog as="div" className="relative z-[5000]" onClose={onClose}>
                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 bg-black bg-opacity-25" />
                </Transition.Child>

                <div className="fixed inset-0 overflow-y-auto">
                    <div className="flex min-h-full items-center justify-center p-4">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 scale-95"
                            enterTo="opacity-100 scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 scale-100"
                            leaveTo="opacity-0 scale-95"
                        >
                            <Dialog.Panel className="w-full max-w-xl transform overflow-hidden rounded-lg bg-white p-6 text-left align-middle shadow-xl transition-all">
                                <div className="flex justify-between items-center mb-4">
                                    <Dialog.Title as="h3" className="text-xl font-semibold text-[#1B2124]">
                                        Choose your plan
                                    </Dialog.Title>
                                    <button onClick={onClose} className="text-gray-400 hover:text-gray-600">
                                        <X size={20} />
                                    </button>
                                </div>
                                <p className="text-[#757575] mb-6">Select batch validity plan</p>

                                <RadioGroup value={selected} onChange={setSelected} className="flex items-center justify-center gap-4 mx-auto">
                                    {plans?.map((plan: any) => (
                                        <RadioGroup.Option
                                            key={plan.id}
                                            value={plan}
                                            className={({ checked }) =>
                                                `relative rounded-xl border p-3 cursor-pointer shadow-sm transition h-[180px] w-[160px] ${checked ? 'border-[#5a4bda] ring-2 ring-[#5a4bda]' : 'border-gray-300'
                                                }`
                                            }
                                        >
                                            {({ checked }) => (
                                                <div className='flex flex-col justify-center items-center mt-3'>
                                                    {plan?.isBest && (
                                                        <div className="absolute -top-2 left-8">
                                                            <span className="bg-green-600 text-white text-xs px-2 py-0.5 rounded-t-md">Recommended</span>
                                                        </div>
                                                    )}
                                                    <div className="text-[#5a4bda] font-semibold text-lg text-center">{plan?.title}</div>
                                                    <div className="my-2 border-t" />
                                                    <div className="text-center">
                                                        <div className="text-lg font-semibold">
                                                            {"₹" + Math.ceil(plan?.priceAfterDiscount)}{' '}
                                                            <span className="line-through text-gray-400 text-sm">{Math.ceil(plan?.price)}</span>
                                                        </div>
                                                        <div className="text-gray-600">{"₹" + Math.ceil(plan?.pricePerMonth) + " " + "/month"}</div >
                                                        <div className="inline-block mt-2 bg-green-100 text-green-700 text-xs px-3 py-1 rounded-full font-medium">
                                                            {Math.ceil(plan?.discount) + "%"}
                                                        </div>
                                                    </div>
                                                    {checked && (
                                                        <div className="absolute -bottom-3 left-1/2 transform -translate-x-1/2">
                                                            <div className="bg-[#5a4bda] text-white p-1 rounded-full">
                                                                <Check size={16} />
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            )}
                                        </RadioGroup.Option>
                                    ))}
                                </RadioGroup>

                                {selected?.validityEndDate && <div className="mt-6 bg-[#edf1ff] text-[#2c2e35] text-sm px-4 py-3 rounded-md text-center">
                                    Batch valid for <strong>{selected?.duration + " " + selected?.durationType}</strong> till <strong>{format(new Date(selected?.validityEndDate), "dd MMM yyyy")}</strong>
                                </div>}
                                <div className='mt-4'>
                                    <Button variant='primary' fullWidth onClick={() => handleMahapackPaymentClose(selected)}>Proceed</Button>
                                </div>
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition>
    );
}
